import { Option } from "../../../components/reusable-components/form/FormAutocomplete";
import { Page } from "./Page";

export interface PageEditConstructor
  extends Omit<
    Page,
    "id" | "domain" | "category" | "domain_id" | "category_id"
  > {
  domain_id: Option;
  category_id: Option;
  featured_image_file?: File | null;
}

export class PageEdit
  implements
    Omit<
      Page,
      | "id"
      | "domain"
      | "category"
      | "categories"
      | "tags"
      | "monthly_price"
      | "yearly_price"
      | "stripe_product_id"
      | "full_url"
    >
{
  public readonly title: string;
  public readonly slug: string;
  public readonly body: string;
  public readonly domain_id: string;
  public readonly category_id: string;
  public readonly featured_image: string | null;

  // read-only (display only)
  public readonly full_url: string | null;
  public readonly stripe_product_id: string | null;
  public readonly monthly_price: string | null;
  public readonly yearly_price: string | null;

  constructor(
    props: PageEditConstructor &
      Partial<
        Pick<
          Page,
          "full_url" | "stripe_product_id" | "monthly_price" | "yearly_price"
        >
      >
  ) {
    this.title = props.title;
    this.slug = props.slug;
    this.body = props.body;
    this.domain_id = props.domain_id.value;
    this.category_id = props.category_id.value;
    this.featured_image = props.featured_image ?? null;

    this.full_url = props.full_url ?? null;
    this.stripe_product_id = props.stripe_product_id ?? null;
    this.monthly_price = props.monthly_price ?? null;
    this.yearly_price = props.yearly_price ?? null;
  }

}
